import { Sprite } from 'pixi.js';
import Core from '../../../Core/Core';
import { IRewardItem } from '../../../State/reducers/score';
import { createOutlineText } from '../../../Utils/Utils';
import { ItemIDs } from '../../../Config/Items';
import { CollectablesProgressBar } from '../Journal/Collectables/CollectablesProgressBar';

export class RewardGroup extends Sprite {
    private txt: PIXI.Text;
    private readonly ammount: number;
    private readonly progressBar: CollectablesProgressBar;

    constructor(
        id: string,
        val?: number | IRewardItem[],
        collectionInProgress?: string,
        collectableProgress?: number
    ) {
        super();

        let iconId = 'commonui/' + id;
        const iconScale = 1;
        switch (id) {
            case ItemIDs.COINS:
                iconId = 'commonui/reward-coin01';
                if (val > 500) {
                    iconId = 'commonui/leaderboard-reward-coins';
                } else if (val > 10) {
                    iconId = 'commonui/reward-coin02';
                }
                break;
            case ItemIDs.HEART:
            case 'Box':
                iconId = 'commonui/reward-heart';
                break;
            case ItemIDs.HIGHLIGHT:
                iconId = 'commonui/reward-highlight';
                break;
            case ItemIDs.COLLECTABLE_TOKEN:
                iconId = 'commonui/reward-token-' + collectionInProgress.toLowerCase();
                break;
            case ItemIDs.SHUFFLE:
                iconId = 'mapui/booster-shuffle';
                break;
            case ItemIDs.TIME:
                iconId = 'mapui/booster-time';
                break;
            default:
                iconId = 'commonui/reward-' + id.toLowerCase();
        }

        const icon = this;
        this.texture = PIXI.utils.TextureCache[iconId];

        icon.anchor.set(0.5);
        icon.scale.set(iconScale);
        let txt = null;
        if (val <= 1) {
            if (id === ItemIDs.COINS) {
                txt = Core.local.getText('coin');
            } else if (id === ItemIDs.HEART) {
                txt = Core.local.getText('life');
            }
        }
        if (!txt) {
            let locId = id.toLowerCase();
            if (id === ItemIDs.TIME) {
                locId = 'Clock';
            }
            txt = Core.local.getText(locId);
        }

        if (val) {
            const textDisplay = createOutlineText(
                '+' + val + '\n' + txt,
                new PIXI.Rectangle(0, icon.height * 0.5, icon.width * 2, icon.height * 0.3),
                'Baloo',
                21,
                21,
                0xffffff,
                0x2a3a71,
                4
            );
            textDisplay.anchor.set(0.5, 0);

            if (id === ItemIDs.COLLECTABLE_TOKEN) {
                const progressBar = (this.progressBar = new CollectablesProgressBar(
                    collectableProgress,
                    textDisplay.width * 2,
                    textDisplay.height / 2
                ));
                progressBar.y = textDisplay.y + textDisplay.height * 1.4;
                this.ammount = val as number;
                this.addChild(progressBar);
            }
            this.addChild(textDisplay);

            this.txt = textDisplay;
        }
    }

    public showFX() {
        if (this.txt) {
            this.txt.alpha = 1;
        }

        if (this.progressBar) {
            this.progressBar.progress += this.ammount;
        }
    }

    public initBox() {}
}
